import LandAssignENSPage from './LandAssignENSPage.container'
export default LandAssignENSPage
